import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { EMPTY, Observable } from 'rxjs';
import { BaseService } from '../../../../services/framework/base.service';
import { FeatureAccessService } from '../../../../services/framework/featureaccess.service';
import { ServiceItem } from '../../../../services/framework/serviceitem';
import { ModalOptions } from '../../widgets/models/modal-options';
import { Tile } from '../../widgets/tile/tile.component';

@Injectable({
  providedIn: 'root'
})
export class TaskListService extends BaseService<TaskListItem> implements Resolve<any> {
  constructor(http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, private router: Router, @Inject('CONFIG_SETTINGS') config: any, private modalService: NgbModal, private featureAccess: FeatureAccessService) {
    super(http, auth);
    const configSettings = config['general'];
    this.apiKey = configSettings['apiKey'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.getEndpoint = 'tasklist/';
  }
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var mipmanager = this.featureAccess.getAccessPermission('/mip/manager');
    if (mipmanager) {
      return this.getTasklists(mipmanager);
    }
    else {
      return this.getTasklists(false);
    }
  }

  public getTasklists(mipadmin: boolean): Observable<TaskListItem[]> {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "GetTasklists/" + mipadmin;
    if (token != undefined) {
      return this.http.get<TaskListItem[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  ngOnInit() {

  }

  showTask(tasklistId: string, text: string) {
    let params: any[] = [];

    let options: ModalOptions = {
      title: text + ' Task List',
      showSave: true,
      showCancel: true,
      showCross: true,
      showFullscreen: true
    };

    params.push(tasklistId);

    //displayModalComponent(TasksEditComponent, 'xl', options, this.modalService, params);

  }

  public SaveTasklist(tasklistitem: TaskListItem) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "SaveTasklist";

    if (token != undefined) {
      tasklistitem.id = "00000000-0000-0000-0000-000000000000";
      if (tasklistitem.private != true) {
        tasklistitem.private = false;
      }
      return this.http.post(url, tasklistitem, this.getHttpOptions(token))
        .subscribe(response => console.log('Response:', response),
          err => console.log(err));
    }
    else {
      return EMPTY;
    }
  }
  public savechecklist(tasklistitem: TaskListItem) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "savechecklist";

    if (token != undefined) {
      tasklistitem.id = "00000000-0000-0000-0000-000000000000";
      if (tasklistitem.private != true) {
        tasklistitem.private = false;
      }
      return this.http.post(url, tasklistitem, this.getHttpOptions(token))
        .subscribe(response => console.log('Response:', response),
          err => console.log(err));
    }
    else {
      return EMPTY;
    }
  }
}



export interface TaskListItem extends ServiceItem {
  text: string;
  private: boolean;
  imageUrl: string;
  actionUrl: string;
  routerLink: string;
  target: string;
  sortOrder: number;
  owner: string;
  isActive?: boolean;
  tile: Tile;
  isArchived: boolean;
  IsMarketInsight: boolean;
  isOwner: boolean;
  router?: string;
  checkList?: boolean;
  clientId?: string;
  mipadmin?: boolean;
}

